/**
 * SIL-2488 (counsel c1): names Escrow.com as the licensed escrow agent. Render this on every customer surface that
 * shows escrow. The text and licence numbers live in @siliconx/shared (escrow-agent.ts); do not retype them here.
 */
import {
  ESCROW_AGENT,
  ESCROW_AGENT_DISCLOSURE_TEXT,
  ESCROW_AGENT_LICENSE_LINK_LABEL,
  ESCROW_AGENT_ROLE_TEXT,
} from '@siliconx/shared';

export function EscrowAgentDisclosure({ className }: { className?: string }) {
  return (
    <p className={className ?? 'text-xs text-zinc-500'} data-testid="escrow-agent-disclosure">
      {ESCROW_AGENT_DISCLOSURE_TEXT} {ESCROW_AGENT_ROLE_TEXT}{' '}
      <a
        href={ESCROW_AGENT.licenseUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        {ESCROW_AGENT_LICENSE_LINK_LABEL}
      </a>
    </p>
  );
}
